import React from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import SettingsIcon from '@mui/icons-material/Settings';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';

interface LandingPageProps {
  onSelect: (page: 'coach' | 'meal' | 'settings' | 'userStats' | 'weightEntry' | 'dailyActivity') => void;
}

const buttonData = [
  {
    label: 'Coach',
    icon: <PersonIcon sx={{ fontSize: 48, color: '#00A3FF' }} />,
    value: 'coach',
  },
  {
    label: 'Meal Entry',
    icon: <FastfoodIcon sx={{ fontSize: 48, color: '#00A3FF' }} />,
    value: 'meal',
  },
  {
    label: 'Weight Entry',
    icon: <MonitorWeightIcon sx={{ fontSize: 48, color: '#00A3FF' }} />, // Scale icon for weight entry
    value: 'weightEntry',
  },
  {
    label: 'Daily Activity',
    icon: <DirectionsRunIcon sx={{ fontSize: 48, color: '#00A3FF' }} />,
    value: 'dailyActivity',
  },
  {
    label: 'User Stats',
    icon: <PersonIcon sx={{ fontSize: 48, color: '#00A3FF' }} />,
    value: 'userStats',
  },
  {
    label: 'Settings',
    icon: <SettingsIcon sx={{ fontSize: 48, color: '#00A3FF' }} />,
    value: 'settings',
  },
];

const LandingPage: React.FC<LandingPageProps> = ({ onSelect }) => (
  <Box sx={{ minHeight: '100vh', bgcolor: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 6 }}>
    <Typography 
      variant="h3" 
      sx={{ 
        fontWeight: 'bold', 
        color: 'primary.main', 
        mb: 6, 
        letterSpacing: 1,
        display: { xs: 'none', sm: 'block' } // Hide on mobile, show on sm+
      }}
    >
      Intuitive Fat Loss
    </Typography>
    <Grid container spacing={5} justifyContent="center" sx={{ maxWidth: 400 }}>
      {buttonData.map(btn => (
        <Grid item xs={12} sm={4} key={btn.value} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Button
            onClick={() => onSelect(btn.value as 'coach' | 'meal' | 'settings' | 'userStats' | 'weightEntry' | 'dailyActivity')}
            sx={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              bgcolor: '#444',
              mb: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: 2,
              '&:hover': { bgcolor: '#222' },
            }}
          >
            {btn.icon}
          </Button>
          <Typography variant="subtitle1" sx={{ color: '#666', fontWeight: 500 }}>
            {btn.label}
          </Typography>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default LandingPage;
